module.exports = __webpack_public_path__ + "img/bocce.e534b081.svg";